import { referralRewardRuleSchema } from "./referral-reward-rule";
import { createZodDto } from "nestjs-zod/dto";

const updateReferralRewardRuleSchema = referralRewardRuleSchema
  .pick({
    quotas: true,
    operator: true,
    amount: true,
    rateId: true,
    type: true,
    is_active: true,
  })
  .partial();

export class UpdateReferralRewardRuleDto extends createZodDto(updateReferralRewardRuleSchema) {}
